module.exports = __webpack_public_path__ + "img/dropsBanner_1248.7b781d6a.png";